import {ReactElement} from 'react';
import {Navigate} from 'react-router';

export default function Home(): ReactElement {
	return <Navigate to="/feeds" />;
}
